export default __webpack_public_path__ + "static/media/100_42411.a6837b9b.jpg";